import EditTransaction from './EditTransaction';

const EditRecurringPayment = (props) => {
  return <EditTransaction returnTo="/recurring-payments" isRecurring={true}/>;
};

export default EditRecurringPayment;